"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const applyCommand_1 = require("../applyCommand");
const getLibraryVersion_1 = require("../helpers/getLibraryVersion");
const validateUser_1 = require("../helpers/validateUser");
function executeCommand(command, user, content, childContents, states, enrolments, stateInteractions) {
    validateUser_1.validateUser(user, { command, caller: 'executeCommand' });
    const events = [];
    let updatedStates = states;
    let updatedStateInteractions = stateInteractions;
    let updatedEnrolments = enrolments;
    const applyPayload = applyCommand_1.applyCommand(command, user, content, childContents, updatedStates, enrolments, stateInteractions);
    updatedEnrolments = applyPayload.enrolments;
    updatedStates = applyPayload.states;
    updatedStateInteractions = applyPayload.stateInteractions;
    events.push(...applyPayload.events);
    command.libraryVersion = getLibraryVersion_1.getLibraryVersion();
    return {
        events,
        states: updatedStates,
        stateInteractions: updatedStateInteractions,
        enrolments: updatedEnrolments
    };
}
exports.executeCommand = executeCommand;
//# sourceMappingURL=index.js.map